// src/api/blog.js
import client from './client.js';

export const blogAPI = {
  getAll: (params) => client.get('/blog', { params }),
  getById: (id) => client.get(`/blog/${id}`),
  create: (data) => client.post('/blog', data),
  update: (id, data) => client.put(`/blog/${id}`, data),
  delete: (id) => client.delete(`/blog/${id}`),
  getComments: (postId, params) => client.get(`/blog/${postId}/comments`, { params }),
  addComment: (postId, data) => client.post(`/blog/${postId}/comments`, data),
  approveComment: (id) => client.put(`/blog/comments/${id}/approve`),
};